import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const gmpPostSendLowMaterials = createApi(`GMPSendToS4Slice`,"POST");

const GMPSendToS4Slice = createSlice({
  name: 'GMPSendToS4Slice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(gmpPostSendLowMaterials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(gmpPostSendLowMaterials.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(gmpPostSendLowMaterials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GMPSendToS4Slice.reducer;